import { render, staticRenderFns } from "./PermissionDataRuleList.vue?vue&type=template&id=4a3afadc&"
import script from "./PermissionDataRuleList.vue?vue&type=script&lang=js&"
export * from "./PermissionDataRuleList.vue?vue&type=script&lang=js&"
import style0 from "./PermissionDataRuleList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports